import { useContext } from 'react';
import { HistoryContext } from '../../components/compat-router/CompatRouter';
import { CustomBrowserHistory } from '../../../core/interfaces/routing';

export function useHistory(): CustomBrowserHistory {
  return useContext(HistoryContext);
}
